import { Vec2 } from '../math/Vec2';
import { POWERUP } from '../config/constants';

export enum PowerUpType {
  ONE_UP = 0,
  MULTIBALL = 1,
  SHIELD = 2,
  EMP_FREEZE = 3,
}

export class PowerUp {
  pos: Vec2;
  radius: number = POWERUP.RADIUS;
  type: PowerUpType;
  color: string;
  angle: number = 0;
  life: number = POWERUP.LIFETIME_TICKS;
  isExpired: boolean = false;

  constructor(pos: Vec2, type: PowerUpType) {
    this.pos = pos.clone();
    this.type = type;

    switch (type) {
      case PowerUpType.ONE_UP:
        this.color = '#00ff55';
        break;
      case PowerUpType.MULTIBALL:
        this.color = '#ffff00';
        break;
      case PowerUpType.SHIELD:
        this.color = '#00aaff';
        break;
      case PowerUpType.EMP_FREEZE:
        this.color = '#00ffff';
        break;
    }
  }

  update(): void {
    this.life--;
    this.angle += 0.05;
    if (this.life <= 0) {
      this.isExpired = true;
    }
  }
}
